import { AppDate } from '@macs-frontend/core/utils/date';
import { AppDateTime } from '@macs-frontend/core/utils/datetime';
import { UUID } from '@macs-frontend/core/utils/uuid';
import {
  AbstractLocation,
  BookingPerson,
  Distance,
} from '@macs-frontend/web-macs/shared';
import { ExternalUsersDrivingLicense } from '@macs-gql';
import { Knowledge } from './../../human-resources/models/knowledge';
import { GeoCountry } from './geo';

export interface BaseExternalUser {
  uuid?: UUID;
  firstName: string;
  lastName: string;
  avatar?: string;
  role?: string;
  professionalStatus?: string;
  socialSecurityNumber?: string;
  birthday?: AppDate;
  status?: ExternalUserStatus;
  availabilityStatus: ExternalUserAvailabilityStatus;
  visitDate?: AppDateTime;
  city?: string;
  street?: string;
  postalCode?: string;
  nr?: string;
  state?: string;
  preferredLanguage?: string;
  fullName?: string;
  fuelCode?: string;
  drivingLicenses?: ExternalUsersDrivingLicense[];
}

export interface ExternalUser extends BaseExternalUser {
  bookingPersons: BookingPerson[];
  location?: ExternalUserLocation;
  country?: GeoCountry;
  knowledge?: Knowledge[];
  phones: ExternalUserPhone[];
}

export interface ExternalUserPublic
  extends Pick<ExternalUser, 'firstName' | 'lastName' | 'visitDate'> {}

export interface ExternalUserPhone {
  label: string;
  number: string;
}

export interface ExternalUserLocation extends AbstractLocation {
  companyDistance?: Distance;
}

export enum ExternalUserStatus {
  EMPLOYED = 'EMPLOYED',
  ARCHIVED = 'ARCHIVED',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
  INVITED_PENDING = 'INVITED_PENDING',
  INVITED_REJECTED = 'INVITED_REJECTED',
  INVITED_CONFIRMED = 'INVITED_CONFIRMED',
}

export enum ExternalUserAvailabilityStatus {
  ACTIVE = 'ACTIVE',
  BLACKLIST = 'BLACKLIST',
  INACTIVE = 'INACTIVE',
  BENCHED = 'BENCHED',
  OUT = 'OUT',
}
